import { IState } from "../..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import { AccessorialReviewPerformanceSummaryState } from "../ShipmentReconciliationState";
import ShipmentReconciliationService from "../../../app/data/shipment-reconciliation/shipmentReconciliationService";
import { AccessorialReviewTerminalPerformanceRequest } from "app/data/shipment-reconciliation/models";

const initialState: AccessorialReviewPerformanceSummaryState = {
  loading: false,
  loadingFailed: false,
  loaded: false,
  summary: {
    totalAcceptedAmount: 0,
    averageAcceptedAmount: 0,
    averageOperationsReviewTime: 0,
    averageBillingReviewTime: 0,
    operationsPending: 0,
    operationsAccepted: 0,
    operationsRejected: 0,
    operationsExpired: 0,
    billingPending: 0,
    billingAccepted: 0,
    billingRejected: 0,
    billingExpired: 0
  }
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const accessorialReviewPerformanceSummarySlice = createSlice({
  name: "accessorialReviewPerformanceSummarySlice",
  initialState,
  reducers: {
    resetAccessorialReviewPerformanceSummaryState: (state) => initialState,
    accessorialReviewPerformanceSummaryLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    accessorialReviewPerformanceSummarySucceed: (state, { payload }) => {
      state.loaded = true;
      state.loading = false;
      state.loadingFailed = false;
      state.summary = {...payload};
    },
    accessorialReviewPerformanceSummaryLoadingFailed: (state) => {
      state.loading = false;
      state.loadingFailed = true;
      state.summary = {...initialState.summary};
    }
  },
});

export const {
  resetAccessorialReviewPerformanceSummaryState,
  accessorialReviewPerformanceSummaryLoadingStarted,
  accessorialReviewPerformanceSummarySucceed,
  accessorialReviewPerformanceSummaryLoadingFailed,
} = accessorialReviewPerformanceSummarySlice.actions;

export const accessorialReviewPerformanceSummarySelector = (state: IState) => state.accessorialReviewPerformanceSummary;

export const getAccessorialReviewPerformanceSummary = (
  requestData: AccessorialReviewTerminalPerformanceRequest,
  onError?: (error: string) => void
): AppThunk => async (dispatch) => {
  dispatch(accessorialReviewPerformanceSummaryLoadingStarted());
  const response = await shipmentReconciliationService.getAccessorialReviewPerformanceSummary(requestData);
  if (response.ok() && response.data) {
    dispatch(accessorialReviewPerformanceSummarySucceed(response.data));
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = JSON.stringify(response.data.message);
    dispatch(accessorialReviewPerformanceSummaryLoadingFailed());
    onError && onError(error)
  }
};

const accessorialReviewPerformanceSummaryReducer = accessorialReviewPerformanceSummarySlice.reducer;
export default accessorialReviewPerformanceSummaryReducer;